import styles from "../Styles/dashboard.module.css";
import SettingsMenu from "../Components/Settings/SettingsMenu";
import { useMediaQuery } from "@mui/material";
import TaxRates from "../Components/Settings/TaxRates";
import { useLocation } from "react-router-dom";
import EmailSettings from "../Components/Settings/EmailSettings";
import { settingsMenuEnum } from "../Utils/AutocompleteUtils";
import MainUser from "../MainUser";
import Anaf from "./Anaf";
import IntegrationsSettings from "../Components/Settings/Integrations";
import PriorityColors from "../Components/Settings/PriorityColors";

export default function Settings() {
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const location = useLocation();

  /**
   *
   */
  function showInformation() {
    const path = location.search.split("=");
    switch (path[1]) {
      case settingsMenuEnum.taxRates:
        return <TaxRates />;
      case settingsMenuEnum.emailSettings:
        return <EmailSettings />;
      case settingsMenuEnum.mainUser:
        return <MainUser />;
      case settingsMenuEnum.anaf:
        return <Anaf />;
      case settingsMenuEnum.integrations:
        return <IntegrationsSettings />;
      case settingsMenuEnum.priorityColors:
        return <PriorityColors />;
      default:
        return <TaxRates />;
    }
  }
  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <SettingsMenu />
      {showInformation()}
    </div>
  );
}
